import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const RegisterButton = ({ onClick, disabled }) => {
    const { t } = useTranslation('customer');
    return (
        <button
            data-register
            className={`m2g-customer-save-button m2g-button m2g-button--primary m2g-form-element--full-width ${
                disabled ? 'm2g-button--disabled' : ''
            }`}
            onClick={onClick}
            type="button"
        >
            {Mobi2Go.headoffice.customer_guest_checkout_enabled
                ? t('guest_signup_button')
                : t('signup_button')}
        </button>
    );
};

RegisterButton.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

RegisterButton.defaultProps = {
    onClick: null,
    disabled: false,
};

export default RegisterButton;
